module.exports = __webpack_public_path__ + "static/img/detail-trainW.4db7a5be.png";